import { ExpandMore } from '@mui/icons-material'
import { Accordion, AccordionDetails, AccordionSummary, Chip, Paper, Stack, Typography } from '@mui/material'
import { CustomModal } from '../common/CustomModal'
import { ReportDetailModalProps } from '../../interfaceTypes/props'

export const ReportDetailModal = ({ isOpen, handleClose, reportTemplates }: ReportDetailModalProps) => {
  return (
    <CustomModal title="Available Reports" isOpen={isOpen} handleClose={handleClose} maxWidth="md">
      <Stack spacing={2}>
        <Typography variant="body2" color="text.secondary" pb={2}>
          Browse the report catalog. Expand a group to see its available reports.
        </Typography>

        {reportTemplates?.map((group, idx) => (
          <Accordion key={group.group} defaultExpanded={idx === 0} disableGutters square>
            <AccordionSummary expandIcon={<ExpandMore />}>
              <Stack spacing={0.5} flex={1}>
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                  <Typography variant="subtitle1" fontWeight={600}>
                    {group.label?.trim()}
                  </Typography>
                  <Chip size="small" variant="outlined" label={`${group.selections?.length || 0} reports`} />
                </Stack>

                {group.description && (
                  <Typography variant="body2" color="text.secondary">
                    {group.description}
                  </Typography>
                )}
              </Stack>
            </AccordionSummary>

            <AccordionDetails>
              <Stack spacing={1.5}>
                {group.selections?.map(selection => (
                  <Paper
                    key={selection.selection}
                    variant="outlined"
                    sx={{ p: 1.5, borderColor: 'grey.200', bgcolor: 'grey.50' }}
                  >
                    <Stack spacing={0.75}>
                      <Stack direction="row" alignItems="center" justifyContent="space-between" flexWrap="wrap" gap={1}>
                        <Typography variant="body1" fontWeight={600}>
                          {selection.label?.trim()}
                        </Typography>

                        <Chip
                          size="small"
                          color="primary"
                          variant="outlined"
                          label={`${selection.selectionFields?.length || 0} filters`}
                        />
                      </Stack>

                      {selection.description && (
                        <Typography variant="body2" color="text.secondary">
                          {selection.description}
                        </Typography>
                      )}
                    </Stack>
                  </Paper>
                ))}
              </Stack>
            </AccordionDetails>
          </Accordion>
        ))}
      </Stack>
    </CustomModal>
  )
}
